//Generated at: 2020-11-05 23:22:25
var __upsell_data_array = [{"id":7,"name":"White Marble","enable":1,"meet_products":["1896209121349"],"upsell_products":["1943160946757","1957556355141"]},{"id":17,"name":"Gloss White - Special Edition","enable":0,"meet_products":["4855112138815"],"upsell_products":["2024767881285","1957556355141"]},{"id":8,"name":"Cement","enable":1,"meet_products":["1943160946757"],"upsell_products":["2161144758341","1957556355141"]},{"id":9,"name":"Shiplap","enable":1,"meet_products":["1899549589573"],"upsell_products":["1957556355141","1896209121349"]},{"id":10,"name":"Concrete","enable":1,"meet_products":["1853819158597"],"upsell_products":["1957556355141","1943168843845"]},{"id":11,"name":"All White","enable":1,"meet_products":["2161144758341"],"upsell_products":["2024767881285","1957556355141"]},{"id":12,"name":"Beechwood","enable":1,"meet_products":["2024767881285"],"upsell_products":["2024681209925","1957556355141"]},{"id":13,"name":"Weathered Wood","enable":1,"meet_products":["1943168843845"],"upsell_products":["1853819158597","1957556355141"]},{"id":14,"name":"Slate","enable":1,"meet_products":["3935358746693"],"upsell_products":["1957556355141","1943168843845"]},{"id":15,"name":"Rose Marble","enable":1,"meet_products":["1899546247237"],"upsell_products":["1957556355141","1896209121349"]},{"id":16,"name":"Seafoam","enable":1,"meet_products":["2024681209925"],"upsell_products":["2024767881285","1957556355141"]}];

var __upsell_drawer_paramters = {
  check_express_buttons_class_timer: null,
  max_show_upsell: 3,
  subtotal_shipping_warning: "*Alaska and Hawaii excluded from free shipping",
  free_shipping_total:128
};


function __checkExpressButtonsClass(){
  //console.log("payment_button:"+$(".payment_button").length);
  if( $(".payment_button").length>0 ){
  if( __upsell_drawer_paramters.check_express_buttons_class_timer ) clearTimeout(__upsell_drawer_paramters.check_express_buttons_class_timer);
  }
  else{
  __reRenderExpressCheckoutButtons(true);
  }
}

function __reRenderExpressCheckoutButtons(im){
  if( im ){
    $(".shopify-cleanslate:nth-child(2)").children().children().children().attr("class","payment_button");
  }
  else{
    setTimeout(function(){
      //Remove the original class/style
      $(".shopify-cleanslate:nth-child(2)").children().children().children().attr("class","payment_button");
    }, 2000);
  }
}

function __upsellDrawerInitialize(){
  $("body").addClass("rpu-body");
  window.RPU_Drawer.initialize(__upsell_drawer_paramters);
  let base_ui = $("li");
  let cart_link = "[aria-controls='CartDrawer']";
  $(base_ui).find(cart_link).on('click',function(){
    window.RPU_Drawer.drawerExpendToggle();
  });
  $(base_ui).find(cart_link).attr("aria-controls","drawer");
  $(base_ui).find(cart_link).attr("href","#");

  window.addEventListener('__drawer_cart_total', function(e){
    if( e.detail.total_price>0 ){
      $("#rpu_checkout_container").show();
      __reRenderExpressCheckoutButtons(false);
    }
    else{
      $("#rpu_checkout_container").hide();
    }
  },false);

  window.addEventListener('__drawer_expend', function(e){
    console.log( e.detail );
    if( e.detail ){
      $("body").addClass("rpu-expend-body");
      $("#RPU_Drawer").focus();
      //Try to fix express buttons periodly.
      __upsell_drawer_paramters.check_express_buttons_class_timer = setInterval(function(){__checkExpressButtonsClass()}, 1000);
      //Express checkout buttons
      if( document.getElementById( 'rpu_checkout_container' ) && document.getElementById( 'additional-checkout-buttons' ) ){
        if( $("#rpu_checkout_container").find(".additional-checkout-buttons").length==0 ){
          //Duplicate the express buttons if not copied yet
          document.getElementById( 'rpu_checkout_container' ).innerHTML = document.getElementById( 'additional-checkout-buttons' ).innerHTML;
          __reRenderExpressCheckoutButtons(false);
        }
        //For Cart Page Express checkout buttons in drawer APP
        if( window.location.href.indexOf("/cart")>-1 ){
          $("#AddToCartForm").find(".dynamic-checkout__content").remove();
        }
        if( window.Shopify && Shopify.StorefrontExpressButtons ){
          //Shopify.StorefrontExpressButtons.initialize();
        }
      }
    }
    else{
      $("body").removeClass("rpu-expend-body");
      //Generate Cart Page Express checkout buttons for cart list
      if( window.location.href.indexOf("/cart")>-1 ){
        $("#AddToCartForm").find(".dynamic-checkout__content").remove();
        $($("#additional-checkout-buttons").html()).appendTo("#AddToCartForm");
      }
    }
  }, false);

  
  $( document ).ajaxComplete(function( event, xhr, settings ) {
    //Ajax Added
    if( settings.url.indexOf("/add.js")>-1  ){
      window.RPU_Drawer.initialize(__upsell_drawer_paramters);
      if( window.location.href.indexOf("pages/bundles")==-1 && (typeof _bundles)=="undefined" ){
        //Expend except the bundle page.
        window.RPU_Drawer.drawerExpendToggle();
      }
    }
    else if( settings.url.indexOf("/cart.js")>-1 && $("body").hasClass("ucd-drawer-open") ){
      //Anti original APP
      $("body").removeClass("ucd-drawer-open");
      window.RPU_Drawer.initialize(__upsell_drawer_paramters);
      if( window.location.href.indexOf("pages/bundles")==-1 && (typeof _bundles)=="undefined" ){
        //Expend except the bundle page.
        window.RPU_Drawer.drawerExpendToggle();
      }
    }
  });
  
  $( "body" ).click(function( event ) {
    if( $(event.target).parent().attr("aria-controls") ) return;  //Except the cart icon
    console.log('entro')
    if( $("body").hasClass("rpu-expend-body") && $(event.target).closest(".rpu-drawer_container").length==0 ){
      // window.RPU_Drawer.drawerExpendToggle();
    }
  });
  $( ".gray_covert" ).click(function( event ) {
    window.RPU_Drawer.drawerExpendToggle();
  });

  if( window.location.href.indexOf("#cart_drawer_open")>-1  ){
    setTimeout(function(){ 
      window.RPU_Drawer.drawerExpendToggle();
    }, 500);
  }
}

$(document).ready(function () {
  if( __config.cart_type != "app" ) return;
  $("a.site-header__cart-toggle").attr("href","#");
  /*
  __upsellDrawerInitialize();
    
  if( window.location.href.indexOf("#cart_drawer_open")>-1  ){
    setTimeout(function(){ 
      window.RPU_Drawer.drawerExpendToggle();
    }, 500);
  }
  */
  
  window.addEventListener('__drawer_cart_total', function(e){
    $("#CartCount").html( e.detail.item_count );
    if( e.detail.item_count==0 ){
      $("#CartCount").hide();
    }
    else{
      $("#CartCount").show();
    }
  },false);
});